export default __webpack_public_path__ + "static/media/2019 Brochure.884df9db.pdf";